import styled from 'styled-components';
import React from 'react';
import { ReactComponent as LogoLarge } from 'assets/white-logo.svg';
import { ReactComponent as LogoSmall } from 'assets/white-logo-small.svg';

const Footer = styled.div`
  padding-top: 12px;
  padding-bottom: 24px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

const PoweredBy = styled.div`
  color: white;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  .logo-large {
    width: 90px;
  }
  .logo-small {
    width: 12px;
    height: 12px;
  }
`;

export default function MenuFooter({ isOpened }) {
  return (
    <Footer>
      <PoweredBy>
        {isOpened ? (
          <>
            <span>Powered by &nbsp;</span>
            <LogoLarge className="logo-large" />
          </>
        ) : (
          <LogoSmall className="logo-small" />
        )}
      </PoweredBy>
    </Footer>
  );
}
